import { render, staticRenderFns } from "./storeInformation.vue?vue&type=template&id=1087a9d1&"
import script from "./storeInformation.vue?vue&type=script&lang=js&"
export * from "./storeInformation.vue?vue&type=script&lang=js&"
import style0 from "./storeInformation.vue?vue&type=style&index=0&id=1087a9d1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports